var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.33 368.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M449.48,326.41V40.84H41.52v46.53c0,2.66-6.56,9.88-8.98,11.41-10.68,6.77-25.34,1.88-29.67-9.73C-.74,79.41-.37,33.15.89,21.24,2.06,10.19,6.94,3.03,18.02.13l453.82-.13c7.98.17,13.9,5.08,17.44,11.88l1.06,336.91c-.59,9.66-9.14,17.57-18.55,18.43l-187.29-.12c-17.71-2.91-25.03-26.66-9.35-37.17,1.17-.78,5.9-3.51,6.69-3.51h167.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89,206c26.72-4.87,68.02,11.27,89.47,27.22,33.74,25.08,60.71,72.61,58.02,115.45-1.23,19.67-25.58,28.01-36.79,11.2-5.91-8.86-3.52-17.45-4.9-26.97-5.22-35.88-32.53-69.44-66.88-81-13-4.38-21.39-3.82-34.1-5.42-26.46-3.34-25.79-36.67-4.82-40.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.99,327.14c30.47-5.58,32.5,37.74,7.22,40.41-25.55,2.7-31.37-35.98-7.22-40.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.29,140.31c29.36-5.35,79.92,11.63,105.74,26.26,58.15,32.95,110.74,111.57,102.44,180.64-1.69,14.04-18.41,21.64-30.57,13.93-13.25-8.4-8.81-21.91-10.28-34.34-9.55-80.56-69.91-137.13-149.79-145.98-8.49-.94-15.37,1.9-23.51-3.26-14.77-9.37-11.27-34.11,5.97-37.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.43,267.04c43.32-7.91,94.28,43.34,85.46,86.74-2.55,12.53-19.19,18.9-30.24,11.71-13.78-8.96-7.57-23.12-13.85-35.86-4.22-8.56-15.06-17.72-24.17-20.45-7.2-2.16-14.17-.62-20.69-3.53-17.33-7.75-14.91-35.24,3.49-38.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshare);
export default __webpack_public_path__ + "static/media/screenshare.061f761ec89c477484b5179f9003962e.svg";
export { ForwardRef as ReactComponent };